var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DialogDownload',{attrs:{"name":_vm.name,"id":_vm.id,"archive":true},scopedSlots:_vm._u([{key:"activator",fn:function({on, attrs}){return [_c('v-chip',_vm._g(_vm._b({attrs:{"link":"","title":_vm.name}},'v-chip',attrs,false),on),[_c('v-icon',[_vm._v(_vm._s(_vm.icons.zip))])],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }